// Compass heading from the device, degrees clockwise from true/magnetic north.
// iOS needs DeviceOrientationEvent.requestPermission() from a tap and reports webkitCompassHeading.
// Android/Chrome reports `deviceorientationabsolute` with alpha counter-clockwise from north.

/** Returns 'ok' | 'denied' | 'unsupported'. Call from a user gesture (button tap). */
export async function startCompass(onHeading) {
  const DOE = globalThis.DeviceOrientationEvent;
  if (!DOE) return 'unsupported';

  if (typeof DOE.requestPermission === 'function') {
    let result;
    try { result = await DOE.requestPermission(); } catch { return 'denied'; }
    if (result !== 'granted') return 'denied';
    window.addEventListener('deviceorientation', (e) => {
      if (typeof e.webkitCompassHeading === 'number') onHeading(e.webkitCompassHeading);
    });
    return 'ok';
  }

  if ('ondeviceorientationabsolute' in window) {
    window.addEventListener('deviceorientationabsolute', (e) => {
      if (e.alpha == null) return;
      const screenAngle = globalThis.screen?.orientation?.angle ?? 0;
      onHeading((360 - e.alpha + screenAngle) % 360);
    });
    return 'ok';
  }
  return 'unsupported';
}

/** Smooth noisy compass readings without spinning the wrong way across north. */
export function smoother(factor = 0.25) {
  let current = null;
  return (deg) => {
    if (current == null) { current = deg; return current; }
    const delta = ((deg - current + 540) % 360) - 180;
    current = (current + delta * factor + 360) % 360;
    return current;
  };
}
